<template>
  <b-modal ref="dashboardACModal" hide-footer centered title="Dasbhoard Access Control" size="lg">
    <b-form-group label="Search:">
      <b-form-input v-model="searchKey" ref="searchInput" />
    </b-form-group>
    <b-table striped hover :items="items" :fields="fields" v-if="users && access">
      <template slot="email" slot-scope="row">
        <span v-if="row.item.email">{{ row.item.email }}</span>
        <span v-else style="color: #bbb;" :title="row.item.uid">
          <i>anonymous: ...{{ (row.item.uid).slice(-5) }}</i>
        </span>
      </template>

      <template v-slot:cell(edit)="row">
        <b-button size="sm" @click="row.toggleDetails" class="mr-2">
          <span v-if="row.detailsShowing">
            <icon name="long-arrow-up" />
            <span>Hide</span>
          </span>
          <span v-else>
            <icon name="long-arrow-down" />
            <span>Show</span>
          </span>
        </b-button>
      </template>

      <template slot="row-details" slot-scope="row">
        <b-form
          :id="`d-access-edit-${currentDash}-${row.item.uid}`"
          @submit.prevent="saveDashboardAccess(`d-access-edit-${currentDash}-${row.item.uid}`, row.index)"
        >
          <b-form-group label="Role:">
            <b-form-select
              :options="roleOptions"
              class="js-role"
              :value="getRolesVal(row.item)"
              multiple
            ></b-form-select>
          </b-form-group>
          <b-alert
            :show="rolesUpdatedAlerts[`d-access-edit-${currentDash}-${row.item.uid}`]"
            @dismissed="delete rolesUpdatedAlerts[`d-access-edit-${currentDash}-${row.item.uid}`]"
            dismissible
            variant="success"
          >Successfully updated.</b-alert>
          <b-button variant="primary" size="sm" type="submit">Save</b-button>
        </b-form>
      </template>

      <template v-slot:cell(resetPass)="row">
        <a
          href="#"
          @click.prevent="showResetPassForm(row.item.uid)"
          :class="[`js-d-access-reset-pass-link-${row.item.uid}`]"
        >reset</a>
        <b-input-group
          size="sm"
          :class="[`js-d-access-reset-pass-form-${row.item.uid}`]"
          style="display: none;"
        >
          <b-form-input
            :class="`js-d-access-reset-pass-input-${row.item.uid}`"
            @keydown.enter="resetPass(row.item.uid)"
            @keydown.escape.stop="cancelResetPass(row.item.uid)"
            placeholder="Press Escape to cancel"
          />
          <b-input-group-append>
            <b-button
              size="sm"
              text="Button"
              variant="success"
              @click="resetPass(row.item.uid)"
            >Save</b-button>
          </b-input-group-append>
        </b-input-group>
      </template>
    </b-table>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
import { setTimeout } from 'timers'
// helpers
import eventBus from '@/helpers/event-bus'
// services
import db from '@/services/db'
import user from '@/services/user'
import auth from '@/services/auth'

let $ = window.$

export default {
  data() {
    return {
      users: null,
      access: null,
      fields: [
        { key: 'email', label: 'User E-mail' },
        'edit',
        { key: 'resetPass', label: 'Reset Password' },
      ],
      roleOptions: [
        { value: 'read', text: 'Regular' },
        { value: 'update', text: 'Dashboard editor' },
        { value: 'manageUsers', text: 'User manager' },
      ],
      sharedWith: null,
      dashOwner: null,
      searchKey: null,
      rolesUpdatedAlerts: {},
    }
  },
  computed: {
    ...mapState(['currentDash', 'userId', 'userList']),
    items() {
      const items = []

      for (let idx in this.users) {
        const user = this.users[idx]

        if (typeof user !== 'object') continue

        if (this.searchKey) {
          if (!user.email) continue
          if (!~user.email.indexOf(this.searchKey.toLowerCase())) continue
        }

        items.push({
          uid: user.uid,
          email: user.email,
        })
      }

      return items
    },
  },
  methods: {
    async save() {
      if (this.$refs.dashboardACModal) this.$refs.dashboardACModal.hide()
    },
    getRolesVal(item) {
      if (
        this.access.Dashboard[item.uid] &&
        this.access.Dashboard[item.uid][this.currentDash]
      ) {
        return Object.keys(this.access.Dashboard[item.uid][this.currentDash])
      }
      return []
    },
    saveDashboardAccess(refKey, idx) {
      const form = $(`#${refKey}`)[0]
      const row = this.items[idx]

      const roles = $(form)
        .find('.js-role')
        .val()
      const uid = row.uid
      const dId = this.currentDash

      const access = Object.assign({}, this.access)

      if (!access.Dashboard[uid]) access.Dashboard[uid] = {}
      if (access.Dashboard[uid][dId]) access.Dashboard[uid][dId] = {}

      const newRules = {}

      for (let rule of roles) {
        newRules[rule] = true
      }

      access.Dashboard[uid][dId] = newRules

      db.access.saveDashboardAccess({ uid, dId, rules: newRules }).then(() => {
        const a = Object.assign({}, this.rolesUpdatedAlerts)
        a[refKey] = true
        this.rolesUpdatedAlerts = a
      })

      this.access = access
    },
    isOwner(uid) {
      return this.dashOwner === uid ? true : false
    },
    getProfileInfoVal(type, uid) {
      if (!this.profilesInfo[uid]) return ''

      switch (type) {
        case 'name':
          return this.profilesInfo[uid].name
          break
        case 'team':
          return this.profilesInfo[uid].teamName
          break
        case 'website-id':
          return this.profilesInfo[uid].websiteId
          break
      }
    },
    showResetPassForm(key) {
      $(`.js-d-access-reset-pass-link-${key}`).hide()
      $(`.js-d-access-reset-pass-form-${key}`).show()
      $(`.js-d-access-reset-pass-input-${key}`).focus()
    },
    async resetPass(key) {
      const newPass = $(`.js-d-access-reset-pass-input-${key}`).val()

      if (!newPass) return

      const idToken = await auth.getIdToken()

      const vm = this
      const data = {
        idToken,
        uid: key,
        dashboard: vm.currentDash,
        pass: newPass,
      }

      user.resetUserPass(data)

      $(`.js-d-access-reset-pass-link-${key}`).show()
      $(`.js-d-access-reset-pass-form-${key}`).hide()
      $(`.js-d-access-reset-pass-input-${key}`).val('')
    },
    cancelResetPass(key) {
      $(`.js-d-access-reset-pass-link-${key}`).show()
      $(`.js-d-access-reset-pass-form-${key}`).hide()
      $(`.js-d-access-reset-pass-input-${key}`).val('')
    },
  },
  async created() {
    await new Promise(resolve => {
      db.access.read(access => {
        this.access = access

        resolve()
      })
    })

    db.getRef('sharedWith').on('value', snapshot => {
      this.sharedWith = snapshot.val()
      const sharedWithUsers = {}
      if (this.sharedWith) {
        for (let user of this.userList) {
          if (sharedWithUsers) {
            if (this.sharedWith[user.uid]) sharedWithUsers[user.uid] = user
          }
        }

        this.users = sharedWithUsers
      }
    })

    db.getRef('owner').on('value', snapshot => {
      this.dashOwner = snapshot.val()
    })

    eventBus.$on('showDashboardACModal', () => {
      if (this.$refs.dashboardACModal) this.$refs.dashboardACModal.show()

      setTimeout(() => {
        if (this.$refs.searchInput) this.$refs.searchInput.focus()
      }, 500)
    })
  },
  mounted() {
    if (this.$refs.dashboardACModal) {
      $(this.$refs.dashboardACModal['$el']).appendTo('body')
    }
  },
  beforeDestroy() {
    if (this.$refs.dashboardACModal) {
      $(this.$refs.dashboardACModal['$el']).remove()
    }
  },
}
</script>
